import React, { Component } from "react";
import { connect } from "react-redux";

import ScreenMasking from "./ScreenMasking";
import { getIsScreenMasking } from "REDUX/Selector/SessionSelector";

export class ScreenMaskingContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ScreenMasking
        isScreenMasking={this.props.isScreenMasking}
        presenterId={this.props.presenterId}
        uniqueId={this.props.uniqueId}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    isScreenMasking: getIsScreenMasking(state),
  };
};

export default connect(
  mapStateToProps,
)(ScreenMaskingContainer);
